<template>
    <form action="/search" :class="{'fixed left-2 top-2 right-2 z-50 md:static': opened}" v-click-outside="close">
        <div class="relative md:w-60">
            <label class="flex space-x-2 items-center fc-input w-full py-2 md:py-1 px-2 my-0.5 rounded"
                   :class="{
                        'bg-white dark:bg-slate-600 ring-2 ring-orange': focused,
                        'md:bg-orange-200 md:dark:bg-slate-700' : !focused,
                    }"
            >
                <svg-icon @click="toggle" icon="search"
                          class="w-5 h-5 md:w-4 md:h-4 cursor-pointer shrink-0"></svg-icon>

                <input class="focus:outline-none w-full bg-transparent placeholder-black/20  dark:placeholder-white/20"
                       ref="input"
                       :class="{'block' : opened, 'hidden md:block': !opened}"
                       placeholder="Поиск по сайту"
                       v-model="term"
                       @input="search"
                       @keydown="onKeydown"
                       @focus="focus"
                       @blur="blur"
                >
                <svg-icon icon="x-lg" v-if="opened" @click="toggle" class="w-4 h-4 cursor-pointer shrink-0"></svg-icon>
            </label>
            <div v-if="loading || hasResults || notFound"
                 class="absolute text-sm md:text-base rounded-lg p-1 bg-white translate-y-2 dark:bg-slate-700 max-h-60 top-full left-0 right-0 md:left-auto md:min-w-[300px] max-w-[400px] shadow-md overflow-x-hidden overflow-y-scroll no-scroll">
                <div v-if="loading" class="p-2 text-gray-500">
                    Вас много, а я один. Ждите
                </div>
                <div v-else-if="notFound" class="p-2 text-gray-500">
                    Нет ничего
                </div>
                <div v-else class="w-full">
                    <a :href="result.url" v-for="(result, index) in results" :key="index"
                       class="rounded flex w-full items-center space-x-2 py-1 px-2 text-gray hover:bg-gray-100 dark:hover:bg-slate-600">
                        <svg-icon v-if="result.type === 'comment'" icon="chat-fill" class="w-4 h-4 shrink-0"></svg-icon>
                        <svg-icon v-if="result.type === 'post'" icon="file-earmark-post" class="w-4 h-4 shrink-0"></svg-icon>
                        <svg-icon v-if="result.type === 'user'" icon="person-fill" class="w-4 h-4 shrink-0"></svg-icon>
                        <svg-icon v-if="result.type === 'channel'" icon="list-ul" class="w-4 h-4 shrink-0"></svg-icon>
                        <svg-icon v-if="result.type === 'tag'" icon="hash" class="w-4 h-4 shrink-0"></svg-icon>
                        <img v-if="result.img" :src="result.img" class="w-4 h-4 shrink-0 rounded overflow-hidden object-cover">
                        <div class="text-black dark:text-white truncate">
                            {{ result.label }}
                        </div>
                    </a>
                    <div class="text-center p-2 text-sm w-full">
                        <a class="text-blue inline-flex w-full items-center gap-1"
                           :href="'/search/?query=' + encodeURIComponent(term)">
                            <span>Все результаты</span>
                            <svg-icon icon="arrow-right-short" clas="w-3 h-3"></svg-icon>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" name="query" :value="term" class="opacity-0"/>
    </form>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import Label from "../form/label.vue";
import Shortcut from "@codexteam/shortcuts";

let delay = 300;
let timeout;

export default {
    components: {Label},
    data() {
        return {
            term: '',
            results: [],
            loading: false,
            opened: false,
            notFound: false,
            focused: false,
        };
    },
    mounted() {
        let that = this;
        new Shortcut({
            name: 'CMD+K',
            on: document.body,
            callback(event) {
                event.preventDefault();
                that.opened = true;
                setTimeout(() => {
                    that.$refs.input.focus();
                }, 100);

            }
        });
    },
    methods: {
        toggle() {
            this.opened = !this.opened;
        },
        close() {
            this.opened = false;
            this.focused = false;
            this.loading = false;
            this.results = [];
            this.notFound = false;
        },
        focus() {
            this.opened = true;
            this.focused = true;
        },
        blur() {
            // Ставим таймаут, чтобы при клике на результат успевал сработать клик
            setTimeout(() => this.close(), 300);
        },
        onKeydown(event) {
            let key = Number(event.keyCode);
            let isEscape = key === 27;

            if (isEscape) {
                this.close();
            }
        },
        search() {
            if (timeout) {
                clearTimeout(timeout);
            }

            if (this.term.trim().length > 0) {
                timeout = setTimeout(() => {
                    this.loading = true;
                    Client.post('/api/v1.1/search', {
                        query: this.term
                    }).then(response => {
                        this.loading = false;
                        if (this.opened) {
                            this.results = response.data.data;
                            this.notFound = !this.results.length;
                        }
                    }).catch(error => {
                        notify({
                            type: 'error',
                            text: 'Пизда поиску. Звони фиксикам'
                        });
                        this.loading = false;
                    })
                }, delay);
            }
        }
    },
    computed: {
        hasResults() {
            return this.results.length > 0;
        }
    }
}
</script>
